module.exports = __webpack_public_path__ + "static/media/clouds-3.b421d8dd.svg";